import type React from 'react'

export type FlagMeta = {
  label: string
  description: string
  format?: (value: string) => React.ReactNode
}

/** Labels of the pipeline's `otu_evaluation_flag` keys, shared by the order's processing tab and the OTU table's result info. */
export const FLAG_METADATA: Record<string, FlagMeta> = {
  clustering_sequence_count: {
    label: 'Clustered Sequences',
    description: 'Total number of sequences that were grouped during clustering.',
    format: (value) => Number(value).toLocaleString()
  },
  clustering_method_used: {
    label: 'Clustering Method used',
    description:
      'CO1 is usually clustered with swarm for accuracy. Other amplicons and CO1 jobs with a large sequence count are instead clustered with vsearch'
  }
}
